import React from "react";

const Card = ({ as: Tag = "div", interactive = false, className = "", children, ...rest }) => (
  <Tag
    className={["cc-card", interactive && "cc-card--interactive", className]
      .filter(Boolean)
      .join(" ")}
    {...rest}
  >
    {children}
  </Tag>
);

export default Card;
